import { getSum } from "./getSum.js";
/**
 * Gets the mean average from an array of numbers
 *
 * @param array - The array of numbers to be averaged
 * @returns The mean average of the array
 */

export const getMean = array => getSum(array) / array.length;